module.exports = __webpack_public_path__ + "img/1_b.8e19f603.jpg";